import React from 'react';
import { Antd3Form, Antd3FormProps, StyledAntd3Form } from 'common/components/deprecated/antd3';
import { SubmitButton } from 'common/components';
import { AuthType } from '../models/organisationModels';
import { createUpstreamClientRequest } from '../actions/organisationActions';
import { DynamicFieldSet } from 'common/components/deprecated/form';
import { notificationText, showNotification } from 'common/helpers/notifications';
import { extractUrlsFromFieldValues } from '../helpers';

type Props = {
    organisationId: number;
    dispatch: Function;
};
type UpstreamClientProps = Antd3FormProps & Props;

const INITIAL_FORM_VALUES = {
    authType: AuthType.OIDC,
    allowedRedirectUrls: [{ value: '' }],
    allowedWebOrigins: [{ value: '' }],
};

const CreateClientUpstreamComponent: React.FC<UpstreamClientProps> = ({
    form,
    organisationId,
    dispatch,
}) => {
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        form.validateFields((error, values) => {
            if (error) {
                showNotification({ text: notificationText.Error });
                return;
            }
            const { allowedRedirectUrls, allowedWebOrigins } = values;

            const transformedValues = {
                ...values,
                allowedRedirectUrls: extractUrlsFromFieldValues(allowedRedirectUrls),
                allowedWebOrigins: extractUrlsFromFieldValues(allowedWebOrigins),
            };

            dispatch(
                createUpstreamClientRequest({
                    organisationId,
                    type: AuthType.OIDC,
                    ...transformedValues,
                }),
            );
        });
    };

    return (
        <StyledAntd3Form header="Create Upstream Website Client" bigHeader onSubmit={handleSubmit}>
            <DynamicFieldSet
                fieldSetId="allowedRedirectUrls"
                fieldType="textInput"
                initialFields={INITIAL_FORM_VALUES.allowedRedirectUrls}
                label="Redirect URLs"
                placeholder="Redirect URL"
                form={form}
                tooltip="Redirect URL is the URL that will be used to redirect the user after authentication."
            />
            <DynamicFieldSet
                fieldSetId="allowedWebOrigins"
                fieldType="textInput"
                initialFields={INITIAL_FORM_VALUES.allowedWebOrigins}
                label="Allowed Web Origins"
                placeholder="Allowed Web Origin"
                form={form}
                tooltip="Allowed Web Origin is the URL that will be used to redirect the user after authentication."
            />
            <SubmitButton value="Create Upstream Client" />
        </StyledAntd3Form>
    );
};

export const CreateClientUpstream = Antd3Form.create({})(CreateClientUpstreamComponent);
